import { AVSSubStatus } from "~/entities/AVS";

export default function (avsValue: any) {
  const errorMessageToAVSSubStatus = {
    "Street number or box number out of range": AVSSubStatus.outOfRange,
    "Please provide a valid license key for this web service":
      AVSSubStatus.validLicenseKey,
    "Please enter a valid address number.": AVSSubStatus.invalidAddress,
    "Address not found": AVSSubStatus.addressNotFound,
    "Street not found": AVSSubStatus.streetNotFound,
    "# unit not found": AVSSubStatus.unitNotFound,
  };
  if (avsValue.errorCode > 0 && avsValue.errorMessage) {
    const avsSubStatus = errorMessageToAVSSubStatus[avsValue.errorMessage];
    if (avsSubStatus) {
      return avsSubStatus;
    }
  } else {
    return AVSSubStatus.apiAVSFailed;
  }
}
